import { render, staticRenderFns } from "./LibraryCurrentBooks.vue?vue&type=template&id=f4badd2c&"
import script from "./LibraryCurrentBooks.vue?vue&type=script&lang=js&"
export * from "./LibraryCurrentBooks.vue?vue&type=script&lang=js&"
import style0 from "./LibraryCurrentBooks.vue?vue&type=style&index=0&id=f4badd2c&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports